import MobilePaidsForm from "./styles";

export default MobilePaidsForm;
